import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import { DEFAULT_CACHE_VERIFICATION_OPTIONS } from './consts';

var PromiseCache =
/** @class */
function () {
  function PromiseCache() {
    this.cache = null;
  }

  PromiseCache.prototype.run = function (runAction, options) {
    var _this = this;

    if (options === void 0) {
      options = DEFAULT_CACHE_VERIFICATION_OPTIONS;
    }

    if (!this.cache || options.shouldRevalidate) {
      var currentRunningCache_1 = this.cache = runAction().then(function (value) {
        // resolve rice condition case
        if (currentRunningCache_1 !== _this.cache) {
          return _this.cache;
        }

        return value;
      }).catch(function (e) {
        // resolve rice condition case
        if (currentRunningCache_1 === _this.cache) {
          _this.cache = null;
        }

        throw e;
      });
    }

    return this.cache;
  };

  PromiseCache.prototype.set = function (value) {
    this.cache = _Promise.resolve(value);
  };

  PromiseCache.prototype.reset = function () {
    this.cache = null;
  };

  return PromiseCache;
}();

export { PromiseCache };
//# sourceMappingURL=promise-cache.js.map